module.exports = __webpack_public_path__ + "static/img/2.2aed65f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/eng/2.png
// module id = qSuv
// module chunks = 0